import { useCallback, useState, useEffect } from "react"
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap"
import BreadCrumb from "../../Components/BreadCrumb"
import Summary from "./components/Summary"
import Staking from "./pools/Staking"
import StakingFlexLock from "./pools/StakingFlexLock"
import StakingMultRewards from "./pools/StakingMultRewards"

import { formatNumber, formatAmount } from "../../utils"
import { api } from "../../apis/staking/api"
import igspAbi from "../../abi/StakePoolSimpleCombinedNewFTM.json"
import newigspAbi from "../../abi/StakePoolFlexLock.json" // get the last deployed abi
import fidoAbi from "../../abi/FIDO.json"
import idoAbi from "../../abi/FIDO.json"
import stakingAbi from "../../abi/StakePoolSimpleCombinedNew.json"
import widoAbi from "../../abi/WIDO.json"
import spmrv1Abi from "../../abi/StakePoolMultipleRewardsV1.json"
import usdcAbi from "../../abi/USDC.json" // USDC FTM

const NewStaking = ({ location }) => {
    const [stakedAmount, setStakedAmount] = useState(0)
    const [stakedByPools, setStakedByPools] = useState({ igsp: 0, nmpp: 0, ibbp: 0, isip: 0, itip: 0, nftme: 0, igspvz: 0, ghd: 0, dragon: 0 })
    const [igspApy, setIgspApy] = useState(277)
    const [lastReward, setLastReward] = useState(300000)
    const pools = {
        igsp: {
            providerUri: "https://rpc.ftm.tools",
            explorer: "https://ftmscan.com/tx/",
            chainSymbol: "FTM",
            poolSymbol: "IGSP",
            poolName: "Old Idexo General Staking Pool",
            breadCrumb: "Staking General Fantom Pool",
            apy: igspApy + "%",
            next_deadline: "N/A",
            chainId: 250,
            args: { maxPriorityFeePerGas: "0xba43b74000" },
            stakingContractAddress: "0x1fac57c7fcde23376c197e3ba7fa34d2200459fa",
            stakingAbi: igspAbi,
            timeLock: true,
            multRewards: false,
            tokenContractAddress: "0x7aa1d538bc7b8f756179d37fb92dc0435fb71ab1",
            tokenSymbol: "FIDO",
            tokenAbi: fidoAbi
        },
        igspv2: {
            providerUri: "https://rpc.ftm.tools",
            explorer: "https://ftmscan.com/tx/",
            chainSymbol: "FTM",
            poolSymbol: "IGSPv2",
            poolName: "Idexo General Staking Pool V2",
            breadCrumb: "Staking Idexo General Staking Pool V2",
            apy: igspApy + "%",
            next_deadline: "N/A",
            chainId: 250,
            args: { maxPriorityFeePerGas: "0xba43b74000" },
            stakingContractAddress: "0x7428C044400A8c54c5685a7b186Bf80A65B9B6DA",
            stakingAbi: newigspAbi,
            timeLock: false,
            flexLock: true,
            multRewards: true,
            rewardTokens: [
                { address: "0x04068DA6C83AFCFA0e13ba15A6696662335D5B75", abi: usdcAbi },
                { address: "0x7aa1d538bc7b8f756179d37fb92dc0435fb71ab1", abi: fidoAbi }
            ],
            tokenContractAddress: "0x7aa1d538bc7b8f756179d37fb92dc0435fb71ab1",
            tokenSymbol: "FIDO",
            tokenAbi: fidoAbi
        },
        igspvz: {
            providerUri: "https://mainnet.era.zksync.io",
            explorer: "https://explorer.zksync.io/",
            chainSymbol: "ZKSYNC",
            poolSymbol: "IGSPvZ",
            poolName: "Idexo General Pool V2",
            breadCrumb: "ZkSync Staking Idexo General Staking Pool V2",
            apy: igspApy + "%",
            next_deadline: "N/A",
            chainId: 324,
            args: { maxPriorityFeePerGas: 250000000 },
            stakingContractAddress: "0xD64281B0E63486B48927AC895c22905638fC696c",
            stakingAbi: newigspAbi,
            timeLock: false,
            flexLock: true,
            multRewards: true,
            rewardTokens: [
                { address: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C", abi: fidoAbi },
                { address: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C", abi: fidoAbi }
            ],
            tokenContractAddress: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C",
            tokenSymbol: "IDO",
            tokenAbi: fidoAbi
        },
        ghd: {
            providerUri: "https://mainnet.era.zksync.io",
            explorer: "https://explorer.zksync.io/",
            chainSymbol: "ZKSYNC",
            poolSymbol: "GHD",
            poolName: "GasHedge DAO",
            breadCrumb: "GasHedge DAO",
            apy: igspApy + "%",
            next_deadline: "N/A",
            chainId: 324,
            args: { maxPriorityFeePerGas: 250000000 },
            stakingContractAddress: "0xaF529167be629F5724939831bdE6799C761010Ce",
            stakingAbi: newigspAbi,
            timeLock: false,
            flexLock: true,
            multRewards: true,
            rewardTokens: [
                { address: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C", abi: fidoAbi },
                { address: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C", abi: fidoAbi }
            ],
            tokenContractAddress: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C",
            tokenSymbol: "IDO",
            tokenAbi: fidoAbi
        },
        dragon: {
            providerUri: "https://mainnet.era.zksync.io",
            explorer: "https://explorer.zksync.io/",
            chainSymbol: "ZKSYNC",
            poolSymbol: "DRAGON",
            poolName: "Luminous Dragons",
            breadCrumb: "Luminous Dragons",
            apy: igspApy + "%",
            next_deadline: "N/A",
            chainId: 324,
            args: { maxPriorityFeePerGas: 250000000 },
            stakingContractAddress: "0x9BEc4a723D7C5AFE239f23F388Dd9EB7e96fc207",
            stakingAbi: newigspAbi,
            timeLock: false,
            flexLock: true,
            multRewards: true,
            rewardTokens: [
                { address: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C", abi: fidoAbi },
                { address: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C", abi: fidoAbi }
            ],
            tokenContractAddress: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C",
            tokenSymbol: "IDO",
            tokenAbi: fidoAbi
        },
        nmpp: {
            providerUri: "https://rpc.ftm.tools",
            explorer: "https://ftmscan.com/tx/",
            chainSymbol: "FTM",
            poolSymbol: "NMPP",
            poolName: "NFTMe Project Pool",
            breadCrumb: "Staking NFTMe Project Pool",
            apy: "- %",
            next_deadline: "Pool Moved",
            chainId: 250,
            args: { maxPriorityFeePerGas: "0xba43b74000" },
            stakingContractAddress: "0x84D896DA0EaaEF427576f1766850aCB794549785",
            stakingAbi: spmrv1Abi,
            timeLock: true,
            flexLock: false,
            multRewards: true,
            rewardTokens: [{ address: "0x04068DA6C83AFCFA0e13ba15A6696662335D5B75", abi: usdcAbi }],
            tokenContractAddress: "0x7aa1d538bc7b8f756179d37fb92dc0435fb71ab1",
            tokenSymbol: "FIDO",
            tokenAbi: fidoAbi
        },
        nftme: {
            providerUri: "https://mainnet.era.zksync.io",
            explorer: "https://explorer.zksync.io/",
            chainSymbol: "ZKSYNC",
            poolSymbol: "NFTME",
            poolName: "NFTMe Project Pool",
            breadCrumb: "Staking NFTMe Project Pool",
            apy: "- %",
            next_deadline: "1000 DAU",
            chainId: 324,
            args: { maxPriorityFeePerGas: 250000000 },
            stakingContractAddress: "0x0C0F51A81Ec405369D1306EB23955Fd0CbA2b634",
            stakingAbi: newigspAbi,
            timeLock: false,
            flexLock: true,
            multRewards: true,
            rewardTokens: [{ address: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C", abi: fidoAbi }],
            tokenContractAddress: "0xDea6d5161978d36b5C0FA6a491faA754f4BC809C",
            tokenSymbol: "IDO",
            tokenAbi: idoAbi
        },
        ibbp: {
            providerUri: "https://bsc-dataseed.binance.org",
            explorer: "https://bscscan.com/tx/",
            chainSymbol: "BSC",
            poolSymbol: "IBBP",
            poolName: "Idexo BSC Bridge Pool",
            breadCrumb: "Staking Bsc",
            apy: "- %",
            next_deadline: "July 5, Quarterly",
            chainId: 56,
            args: { gas: 250000 },
            stakingContractAddress: "0x5969eba02313719b3729b173657335abc844f248",
            stakingAbi: stakingAbi,
            timeLock: false,
            flexLock: false,
            multRewards: false,
            tokenContractAddress: "0x049EAb8A00E0600622883c8eBa4442bf23ac79A8",
            tokenSymbol: "WIDO",
            tokenAbi: widoAbi
        },
        isip: {
            providerUri: "https://bsc-dataseed.binance.org",
            explorer: "https://bscscan.com/tx/",
            chainSymbol: "BSC",
            poolSymbol: "ISIP",
            poolName: "Idexo Solana Integration Pool",
            breadCrumb: "Staking Integrate Solana",
            apy: "- %",
            next_deadline: "July 5, Quarterly",
            chainId: 56,
            args: { gas: 250000 },
            stakingContractAddress: "0xd499EF4C2F0972714AcEB8663DaD044122A501b4",
            stakingAbi: stakingAbi,
            timeLock: false,
            flexLock: false,
            multRewards: false,
            tokenContractAddress: "0x049EAb8A00E0600622883c8eBa4442bf23ac79A8",
            tokenSymbol: "WIDO",
            tokenAbi: widoAbi
        },
        itip: {
            providerUri: "https://bsc-dataseed.binance.org",
            explorer: "https://bscscan.com/tx/",
            chainSymbol: "BSC",
            poolSymbol: "ITIP",
            poolName: "Idexo Tezos Integration Pool",
            breadCrumb: "Staking Integrate Tezos",
            apy: "- %",
            next_deadline: "July 5, Quarterly",
            chainId: 56,
            args: { gas: 250000 },
            stakingContractAddress: "0x40447E084c47C997Ba2dB8F3038A599098307ebb",
            stakingAbi: stakingAbi,
            timeLock: false,
            flexLock: false,
            multRewards: false,
            tokenContractAddress: "0x049EAb8A00E0600622883c8eBa4442bf23ac79A8",
            tokenSymbol: "WIDO",
            tokenAbi: widoAbi
        }
    }
    const [active, setActive] = useState("")
    const [price, setPrice] = useState(0)
    const [circSupply, setCircSupply] = useState(0)

    const getCircSupply = async () => {
        const data = await api.getCircSupply()
        if (data) {
            setCircSupply(data)
        }
    }
    const getPrice = async () => {
        const data = await api.getPrice()
        if (data) {
            setPrice(data["idexo-token"]["usd"])
            const usdprice = data["idexo-token"]["usd"]
            const apycalc = parseInt(((lastReward * 12) / stakedByPools.igspv2) * 100)
            setIgspApy(apycalc)
        }
    }

    const handleStakedAmount = (symbol, staked) => {
        const pool = symbol.toLowerCase()
        stakedByPools[pool] = staked
        setStakedByPools({ ...stakedByPools })
    }

    useEffect(() => {
        let total = 0
        for (const pool of Object.keys(stakedByPools)) {
            total += parseInt(stakedByPools[pool])
        }
        setStakedAmount(total)
    }, [stakedByPools])

    useEffect(() => {
        try {
            getCircSupply()
            getPrice()
        } catch (error) {
            console.log(error)
        }
        return () => {
            // clean
        }
    }, [])

    const handleExpanded = useCallback(
        (poolId) => {
            if (poolId === active) {
                setActive("")
            } else {
                setActive(poolId)
            }
        },
        [active]
    )
    const pool = new URLSearchParams(location.search).get("pool")?.toLowerCase()

    switch (pool) {
        case "igsp":
            return <Staking pool={pools[pool]} />
        case "igspv2":
            return <StakingFlexLock pool={pools[pool]} />
        case "ibbp":
            return <Staking pool={pools[pool]} />
        case "isip":
            return <Staking pool={pools[pool]} />
        case "itip":
            return <Staking pool={pools[pool]} />
        case "nftme":
            return <StakingFlexLock pool={pools[pool]} />
        case "igspvz":
            return <StakingFlexLock pool={pools[pool]} />
        case "ghd":
            return <StakingFlexLock pool={pools[pool]} />
        case "dragon":
            return <StakingFlexLock pool={pools[pool]} />
        default:
            break
    }

    const marketCap = () => {
        let mc = 0

        if (price && circSupply) {
            mc = parseInt(price * circSupply)
            mc = formatAmount(mc, 2)
        }

        return mc
    }

    return (
        <div className="content stake-page">
            <BreadCrumb items={["Staking Dashboard"]} />
            <div className="stake-body">
                <Card>
                    <CardHeader>
                        <CardTitle className="h3">Idexo Staking</CardTitle>
                    </CardHeader>
                    <CardBody className="dashboard pt-0">
                        <div className="token-info ">
                            <div>
                                <div className="title">IDO PRICE</div>
                                <div className="value">{`$${price}`}</div>
                            </div>
                            <div>
                                <div className="title">CIRCULATING SUPPLY</div>
                                <div className="value">{formatNumber(circSupply)}</div>
                                <div className="subtitle">({parseFloat((circSupply / 100000000) * 100).toFixed(1) + "% of max"})</div>
                            </div>
                            <div>
                                <div className="title">MARKET CAP</div>
                                <div className="value">${marketCap()}</div>
                            </div>
                        </div>
                        <div className="staked-info">
                            <div>
                                <div className="title">Total Staked</div>
                                <div className="value">
                                    {formatNumber(stakedAmount.toFixed(0))} IDO / ${formatAmount(stakedAmount * price, 0)}
                                </div>
                            </div>
                            <div>
                                <div className="title">Rewards Added</div>
                                <div className="value">${formatAmount(220000, 0)}</div>
                            </div>
                            <div>
                                <div className="title">IGSP Est. APY</div>
                                <div className="value">{igspApy}%</div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <div className="pools-body">
                            <div className="pools-header">
                                <div>Symbol</div>
                                <div>Name</div>
                                <div>Total Staked</div>
                                <div>Est. APY</div>
                                <div>Next Deadline</div>
                            </div>
                            <Summary pool={pools.igspvz} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                            <Summary pool={pools.nftme} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                            <Summary pool={pools.ghd} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                            <Summary pool={pools.dragon} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                            <Summary pool={pools.igspv2} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                            <Summary pool={pools.igsp} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                            <Summary pool={pools.nmpp} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                            <Summary pool={pools.ibbp} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                            <Summary pool={pools.isip} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                            <Summary pool={pools.itip} active={active} onExpand={handleExpanded} handleStakedAmount={handleStakedAmount}></Summary>
                        </div>
                    </CardBody>
                </Card>
            </div>
        </div>
    )
}

export default NewStaking
